import { ReactNode } from 'react';
import { Chip } from '@mui/material';

interface IProps {
  label: ReactNode;
  size?: 'small' | 'medium';
  color?: 'warning' | 'disabled';
}

export default function CasChip({ label, size = 'medium', color = 'warning' }: IProps) {
  const sizeMap = {
    small: {
      height: '16px',
      fontSize: '11px',
    },
    medium: {
      fontSize: '12px',
    },
  };

  const bgColor = {
    warning: '#fbf3c0', // light yellow
    disabled: '#EBEBEB', // light gray
  };

  const backgroundColor = color ? bgColor[color] : undefined;

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        ...sizeMap[size],
        color: 'black',
        backgroundColor,
        '&:hover': {
          backgroundColor, // prevent hover color change
        },
        '& .MuiChip-label': {
          paddingLeft: '8px',
          paddingRight: '8px',
        },
      }}
    />
  );
}
